import { HTMLAttributes } from "react";

export default function AngularJS(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
    {...props}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M40 33L28.5 6.5L23.5 3L12.5 13L8 32.5L10.5 37.5L30 39L40 36.5V33Z"
        fill="white"
      />
      <path
        d="M19.8241 24.0001H28.5541L23.9135 14.2963L19.8241 24.0001ZM23.9289 0.384888L1.70752 8.20514L5.21865 37.319L23.9525 47.6154L42.7828 37.1799L46.2928 8.06676L23.9289 0.384888ZM18.0166 28.1251L15.2923 34.9411L10.1994 34.9621L23.9274 4.55751L23.9011 4.50014H23.8771L23.8775 4.45026L23.9011 4.50014H23.954L24.0001 4.39739V4.50014H23.9536L23.9278 4.55751L38.2486 35.0889L33.3459 34.9813L30.3301 28.0138L23.8903 28.0445"
        fill="#C4473A"
      />
    </svg>
  )
}
